import React, { useState } from "react";

import { InfoCircleFilled } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";

import { useAccessStatus } from "../hooks/useAccessStatus";
import { useGraceInvoicePayment } from "../hooks/useGraceInvoicePayment";

import { canMakePayment } from "../../../utils/Permissions";
import { formatDaysRemaining, formatGracePeriodDays } from "../utils";

import { ReactComponent as BackArrowIcon } from "../../../assets/images/backArrowLeft.svg";
import { ReactComponent as LockWarningIcon } from "../../../assets/images/grace-period/LockWarning.svg";

import "./PaymentPendingModal.css";

export default function PaymentPendingModal({ onGoBack }) {
  const history = useHistory();
  const access = useAccessStatus();
  const { isPaymentBusy, startPayNow } = useGraceInvoicePayment();
  const allowPayment = canMakePayment();
  const [dismissed, setDismissed] = useState(false);

  if (!access.isGraceActive || dismissed) {
    return null;
  }

  const daysLeftLabel = formatDaysRemaining(access.grace_days_left);
  const gracePeriodDaysLabel = formatGracePeriodDays(access.grace_days_left);

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
      return;
    }
    history.push("/sample-submission");
  };

  return (
    <Modal
      open
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      width={484}
      wrapClassName="PaymentPendingModalWrap"
      className="PaymentPendingModal"
      classNames={{
        content: "PaymentPendingModal__Content",
        header: "PaymentPendingModal__Header",
        body: "PaymentPendingModal__Main",
      }}
      title={(
        <Button
          type="text"
          icon={<BackArrowIcon className="PaymentPendingModal__GoBackIcon" aria-hidden />}
          className="PaymentPendingModal__GoBack"
          disabled={isPaymentBusy}
          onClick={handleGoBack}
        >
          Go back
        </Button>
      )}
    >
      <div className="PaymentPendingModal__Body">
        <LockWarningIcon className="PaymentPendingModal__LockIcon" aria-hidden />

        <h2 className="PaymentPendingModal__Title">Payment Pending - Result access is limited</h2>
        <p className="PaymentPendingModal__Description">
          You can continue submitting samples during the
          {gracePeriodDaysLabel ? ` ${gracePeriodDaysLabel}` : ""}
          {" "}
          grace period.
          However, completed results, reports, COAs, analytics, and retest actions remain locked until payment is completed.
        </p>

        {daysLeftLabel && (
          <span className="PaymentPendingModal__Badge">
            <InfoCircleFilled aria-hidden />
            Grace Period Active:
            {" "}
            {daysLeftLabel}
          </span>
        )}
      </div>

      <div className="PaymentPendingModal__Actions">
        <Button
          type="default"
          className="PaymentPendingModal__Continue"
          disabled={isPaymentBusy}
          onClick={() => setDismissed(true)}
        >
          Continue with submission
        </Button>
        {allowPayment && (
          <Button
            type="primary"
            className="PaymentPendingModal__PayNow"
            loading={isPaymentBusy}
            disabled={isPaymentBusy}
            onClick={startPayNow}
          >
            Pay now
          </Button>
        )}
      </div>
    </Modal>
  );
}
